<template>
  <div id="organization">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'organization'
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/system/organization/Organization.vue